module.exports = __webpack_public_path__ + "static/media/footerlogo.1f232a87.webp";